import { createFileRoute } from "@tanstack/react-router";

import { PartnerLandingPage } from "@/components/partners/PartnerLandingPage";
import { SITE_URL } from "@/lib/site";

const TITLE = "Zakelijke partners: taxi boeken met commissie | Taxiritje.nl";
const DESCRIPTION =
  "Partners boeken taxivervoer met vaste prijzen voor hun klanten, betalen direct of via betaallink en ontvangen commissie per rit, op bedrijfsfactuur.";

export const Route = createFileRoute("/b2b")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE_URL}/b2b` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: `${SITE_URL}/og/taxiritje-brand.jpg` },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
      { name: "twitter:image", content: `${SITE_URL}/og/taxiritje-brand.jpg` },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/b2b` }],
  }),
  component: PartnerLandingPage,
});
